import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';



  

@Injectable()
export class FeecounterService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl;
         }

         
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=9)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }
        
  by_sp_student(clid:number,secid:number,brid:string): Observable<any> {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sp_student/'+clid+'/'+secid+'/dbnm/'+clcd+'/'+aycd+'/'+brid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data.by_sp_clsSec;
        }));
}

Acreceiptheader(stuid:string,deptid:string) {
    debugger
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
       return this.http.get(this._global.baseAPIUrl + 'acreceipth/'+stuid+'/'+deptid+'/'+clcd+'/'+aycd)
           .pipe(map((data: any) => {

               // console.log=('log',data.classdata)
               return data.rechead;
           }))
   }

   Acreceiptdet(stuid:string,deptid:string,insid:string) {
    debugger
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
       return this.http.get(this._global.baseAPIUrl + 'acreceiptd/'+stuid+'/'+deptid+'/'+insid+'/'+clcd+'/'+aycd)
           .pipe(map((data: any) => {

               // console.log=('log',data.classdata)
               return data.recdet;
           }))
   }


   savepartreceipt(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_Partreceipt', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}



feevocherh(oprtype,sertxt,accatid) {
  debugger
  var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt,accatid:accatid};
     return this.http.post(this._global.baseAPIUrl + 'getfeevouchers',postdata)
         .pipe(map((data: any) => {

              console.log('log',data);
             return data.voucherlst;
         }))
 }

 getvochersbyclass(obj) {
    debugger
   // var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt,accatid:accatid};
   obj.clcd=this.clcd;
   obj.aycd=this.aycd;
   obj.usid=this.usid
       return this.http.post(this._global.baseAPIUrl + 'getfeevouchersbyclass',obj)
           .pipe(map((data: any) => {
  
                console.log('log',data);
               return data.voucherlst;
           }))
   }

   generatevocher(obj,oprtype) {
    debugger
   // var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt,accatid:accatid};
   obj.clcd=this.clcd;
   obj.aycd=this.aycd;
   obj.usid=this.usid;
   obj.oprtype=oprtype;
       return this.http.post(this._global.baseAPIUrl + 'generatevocher',obj)
           .pipe(map((data: any) => {
  
                console.log('log',data);
               return data;
           }))
   }

   updatefeeoptions(obj) {
    debugger
   // var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt,accatid:accatid};
   obj.clcd=this.clcd;
   obj.aycd=this.aycd;
   obj.usid=this.usid;
   
       return this.http.post(this._global.baseAPIUrl + 'updatefeeoptions',obj)
           .pipe(map((data: any) => {
  
                console.log('log',data);
               return data;
           }))
   }
 feevocherd(oprtype,vhno) {
  debugger
  var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,vhno:vhno};
     return this.http.post(this._global.baseAPIUrl + 'getfeevoucherdet',postdata)
         .pipe(map((data: any) => {

             // console.log=('log',data.classdata)
             return data.voucherlst;
         }))
 }

 cancelrec(recid) {
    debugger
    var postdata={clcd:this.clcd,aycd:this.aycd,recid:recid,usid:this.usid};
       return this.http.post(this._global.baseAPIUrl + 'cancelreceipt',postdata)
           .pipe(map((data: any) => {
  
               // console.log=('log',data.classdata)
               return data;
           }))
   }

 feerech(oprtype,vhno) {
    debugger
    var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,vhno:vhno};
       return this.http.post(this._global.baseAPIUrl + 'getpartpayments',postdata)
           .pipe(map((data: any) => {
  console.log('data',data);
               // console.log=('log',data.classdata)
               return data.paylst;
           }))
   }
 feecolrpt(pstdata) {
    debugger
    //var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,vhno:vhno};
    pstdata.clcd=this.clcd;
    pstdata.aycd=this.aycd;
       return this.http.post(this._global.baseAPIUrl + 'getfeecolrpt',pstdata)
           .pipe(map((data: any) => {
  
                console.log('log',data)
               return data.feecollst;
           }))
   }

   getfeesumstu(attdtdata: any): Observable<any> {
    attdtdata.clcd=this.clcd;
    attdtdata.aycd=this.aycd;
    //attdtdata.oprtype1="sum_subwise";
    return this.http.post(this._global.baseAPIUrl + 'getfeesumstu', attdtdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.attsum;
        }));
  }
   feesum(pstdata) {
    debugger
    //var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,vhno:vhno};
    pstdata.clcd=this.clcd;
    pstdata.aycd=this.aycd;
       return this.http.post(this._global.baseAPIUrl + 'getfeesum',pstdata)
           .pipe(map((data: any) => {
  
                console.log('log',data)
               return data.feesumlst;
           }))
   }
 
 
 saveaccvoucherd(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    recdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'saveaccvoucherd', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}

savefeecol(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    recdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_feecol', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}

saveoldstutstudent(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    recdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'saveoldstutstudent', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}

savemiscfee(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    recdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_miscreceipt', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}


savepos(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    recdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_poscoll', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}

paymentrequestdata(obj) {
    debugger
    var postdata={jsonpayrequest:{clcd:this.clcd,aycd:this.aycd,stuid:obj.stuid,insid:obj.insid,deptid:obj.accatid,vhno:obj.vhno}};
    console.log('post',postdata);
       return this.http.post(this.callurl + 'paymentrequestdataweb',postdata)
           .pipe(map((data: any) => {
  console.log('data',data);
               // console.log=('log',data.classdata)
               return data.paymentrequestdataResult;
           }))
   }
  


   payapi(jsonstafupddtls: any): Observable<any> {
        
    // this.callurl='http://49.205.199.224:8082/mychamp/api/v3/ccavencrypt.php';
     // this.callurl=this.baseUrl+'Payenqrequest'
      return this.http.post( this.callurl+"ccavencrypt.php", jsonstafupddtls )
          .pipe(map((data: any) => 
          {
              console.log('retres',data);
              return  data ; 
          }));
   }  
   
   dashoverview() {
    debugger
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
       return this.http.get(this._global.baseAPIUrl + 'feesoverviewdata/'+clcd+'/'+aycd)
           .pipe(map((data: any) => {

               // console.log=('log',data.classdata)
               return data;
           }))
   }

   savelibreceipt(recdata: any): Observable<any> {
    recdata.clcd=this.clcd;
    recdata.aycd=this.aycd;
    recdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_libreceipt', recdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }))
}

getlibreceipts(pstdata) {
    debugger
    //var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,vhno:vhno};
    pstdata.clcd=this.clcd;
    pstdata.aycd=this.aycd;
       return this.http.post(this._global.baseAPIUrl + 'getlibreceipts',pstdata)
           .pipe(map((data: any) => {
  
                console.log('log',data)
               return data.feecollst;
           }))
   }


}